import React, { useEffect } from 'react';

import ListItem from './ListItem';

import useListDragAndDrop from '../../../hooks/useListDragAndDrop';

export default function DraggableList({
  options,
  value,
  setValue,
  tabindex,
  isVisible,
  readOnly,
}) {
  const {
    disableDragOver,
    changeListItemOrder,
    listContainerRef,
    dragListItem,
  } = useListDragAndDrop({
    itemHeight: 39,
    itemsGap: 8,
    itemsList: value,
    onItemsOrderChange: (newValue) => setValue(newValue),
  });

  useEffect(() => {
    if (tabindex === 1 && listContainerRef.current) {
      listContainerRef.current.focus();
    }
  }, [tabindex, isVisible, listContainerRef]);

  if (readOnly) {
    return (
      <ol className="flex flex-col">
        {value?.map((el, index) => (
          <li
            key={el.value}
            className="inline-flex min-w-[20rem] px-4 py-2 rounded-sm text-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-100"
          >
            {index + 1}.{' '}
            {options?.find((option) => option?.value === el?.value)?.label}
          </li>
        ))}
      </ol>
    );
  }

  return (
    <ul
      className="flex flex-col gap-2"
      onDragOver={disableDragOver}
      onDrop={changeListItemOrder}
      ref={listContainerRef}
      tabIndex={tabindex}
    >
      {value?.map((el, index) => (
        <ListItem
          key={el.value}
          option={options.find((option) => option.value === el.value)}
          onDragStart={(event) => dragListItem(event, index)}
          readOnly={readOnly}
        />
      ))}
    </ul>
  );
}
